// Override setupProductTiles to remove Yotpo dependency
(function () {
  // Store the original function
  var originalSetupProductTiles = window.setupProductTiles;

  // Create our new function that wraps the original
  window.setupProductTiles = function () {
    // Call the original function
    if (typeof originalSetupProductTiles === "function") {
      originalSetupProductTiles();
    }
  };

  // Override Yotpo to prevent errors
  window.Yotpo = window.Yotpo || {};
  window.Yotpo.API =
    window.Yotpo.API ||
    function () {
      return {
        refreshWidgets: function () {
          // Do nothing
          return;
        },
      };
    };
  window.yotpo = window.yotpo || {};
})();
